import { Button, Form, Modal, Input, Checkbox, message } from 'antd'
import { IconFont, SignTitle } from '@/components'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelections } from 'ahooks'
import {
  useEditTemplate,
  useGetTemplateDetail,
} from '@/pages/data-protection/template-resources/utils'
import emptyImg from '@/assets/imges/Empty/Empty.png'
import { checkEditName } from '@/api/dp-template'
import { Message } from '@/components/message'
import MarkdownEditor from '@/components/markdown-editor'
import { t } from '@/i18n'

export const EditModal = props => {
  const { visible, setVisible, id } = props
  const { TextArea } = Input
  const [form] = Form.useForm()
  let userData
  try {
    userData = JSON.parse(localStorage.getItem('token') as string)
  } catch (error) {}
  const [type, setType] = useState(null)
  const [checked, setChecked] = useState(false)
  let [fileData, setFileData] = useState('')
  // const [uploadLoading, setUploadLoading] = useState(false)
  // const [fileFailed, setFileFailed] = useState(false)
  let [variables, setVariables] = useState([])
  const [fileName, setFileName] = useState('')
  const { selected, toggle, unSelectAll, isSelected } = useSelections(variables)
  const [detail, getDetail] = useGetTemplateDetail()
  const [editTemplate] = useEditTemplate()
  const [description, setDescription] = useState(null)
  useEffect(() => {
    getDetail({ id })
      .then(res => {
        // console.log(res)
        let item = res.data
        console.log('接口返回：', item.describe)
        setDescription(item.describe)
        setType(item?.file_type)
        if (item.file_type !== 4) {
          setFileData((fileData = item?.content))
          // setVariables(item.items.map(e => e.name))
          onCheckVariable()
          item?.variable_list?.map(e => {
            toggle(e.substring(2, e.length - 2))
          })
        }
        form.setFieldsValue({ name: item.name, describe: item.describe })
      })
      .catch(_ => {})
  }, [])

  const variablesWithInterpretation = [
    { name: 'name_en', value: t('随机英文名字') },
    { name: 'name_cn', value: t('随机中文名字') },
    { name: 'idcard', value: t('随机身份证号') },
    { name: 'bankno', value: t('随机银行卡号') },
    { name: 'phoneno', value: t('随机手机号') },
    { name: 'gender', value: t('随机性别') },
    { name: 'email', value: t('随机邮箱') },
    { name: 'email_account', value: t('生成与当前用户同域的随机邮箱') },
    { name: 'ip_ext', value: t('随机外网ip') },
    { name: 'ip_inter', value: t('随机内网ip') },
    { name: 'HKCardNo', value: t('港澳居民来往内地通行证') },
    { name: 'TWCardNo', value: t('台湾身份证') },
    { name: 'OfficerNo', value: t('军官证') },
    { name: 'AccountNo', value: t('户口本号') },
    { name: 'PassportNo', value: t('护照号码') },
    { name: 'DriverLicenseNo', value: t('驾驶证') },
  ]

  const checkedName = (value: string) =>
    new Promise((resolve, reject) => {
      checkEditName({ name: value, id })
        .then(res => {
          if (res.code === 200) {
            resolve(true)
          } else resolve(false)
        })
        .catch(error => {
          resolve(false)
        })
    })
  const submitHandler = values => {
    //
    const { name } = values
    const item = selected.map(item => `{{${item}}}`)
    let data
    switch (type) {
      case 1:
        data = {
          name: name,
          describe: description,
          content: fileData,
          variable_list: item,
        }
        break
      case 2:
        data = {
          name: name,
          describe: description,
          content: fileData,
          variable_list: item,
        }
        break
      case 3:
        data = {
          name: name,
          describe: description,
          content: fileData,
          variable_list: item,
        }
        break
      case 4:
        data = {
          name: name,
          describe: description,
        }
    }
    editTemplate({ ...data, id, file_type: type })
      .then(() => {
        setVisible(2)
        setDescription(null)
      })
      .catch(_ => {})
  }
  const onSubmit = () => {
    // 确定
    if ([2, 3].includes(type)) {
      if (fileData.length === 0) {
        Message.error(t('数据内容不能为空'))
        return
      }
    }
    // if ([2, 3].includes(type) && fileData.length > 0) {
    //   form.submit()
    // } else if ([2, 3].includes(type)) {
    //   Message.error('数据内容不能为空')
    //   return
    // }
    form.submit()
  }
  const onCheckVariable = () => {
    // 检测变量
    unSelectAll()
    let r = []
    let inBrace = false
    let variable = ''
    for (let i = 0; i < fileData.length; i++) {
      let char = fileData[i]
      let next = ''
      if (i < fileData.length) {
        next = fileData[i + 1]
      }
      if (char == '{' && next == '{') {
        i += 1
        inBrace = true
        continue
      }
      if (inBrace && char !== '}') {
        variable += char
        continue
      }
      if (char == '}' && next === '}') {
        if (inBrace && !r.includes(variable)) {
          r.push(variable)
        }
        i += 1
        inBrace = false
        variable = ''
      }
    }
    const list = variablesWithInterpretation.map(item => item.name)
    let result = r.filter(item => list.includes(item))
    setVariables((variables = result))
    setChecked(false)
  }
  return (
    <Modal
      width="1000px"
      title={
        <SignTitle show style={{ width: '1000px' }}>
          {/*{templateDetail?.title || ''}*/}
          {t('编辑自定义模板')}
        </SignTitle>
      }
      // bodyStyle={{ width: '700px' }}
      centered
      footer={[
        <div>
          <Button
            onClick={() => {
              setVisible(false)
              setDescription(null)
            }}
          >
            {t('取消')}
          </Button>
          <Button disabled={checked} type="primary" onClick={() => onSubmit()}>
            {t('确定')}
          </Button>
        </div>,
      ]}
      visible
      onCancel={() => {
        setVisible(false)
        setDescription(null)
      }}
      bodyStyle={{ maxHeight: '600px' }}
    >
      <Form
        form={form}
        onFinish={val => {
          submitHandler(val)
        }}
        layout={'vertical'}
      >
        <Form.Item
          label={t('模板名称')}
          name="name"
          rules={[
            { required: true, message: t('请输入模板名称') },
            {
              validateTrigger: 'onSubmit',
              validator: (_, value, callback) => {
                if (value?.length > 0) {
                  checkedName(value).then(res => {
                    if (res) {
                      callback()
                      // return Promise.resolve()
                    } else {
                      callback(t('已存在'))
                      // return Promise.reject('此模板中已存在')
                    }
                  })
                } else {
                  callback()
                }
              },
            },
          ]}
        >
          <Input maxLength={60} style={{ width: '420px' }} placeholder={t('请输入')} />
        </Form.Item>
        <div>
          <Readonly>
            <div className="name">{t('文件格式：')}</div>
            {[1, 2, 4].includes(detail.file_type) && (
              <div className="value">{detail.file_name?.split('.')?.[1]}</div>
            )}
            {detail.file_type === 3 && <div className="value">{t('无格式')}</div>}
            {/*{detail.file_type === 4 && <div className="value">{detail.file_name}</div>}*/}
            {/*<div className="value">{type}</div>*/}
          </Readonly>
          {type === 4 && (
            <Readonly>
              <div className="name">{t('数据内容：')}</div>
              <div className="value">
                <IconFont style={{ marginRight: 12 }} type="icon-047-file" />
                {detail.file_name}
              </div>
            </Readonly>
          )}
        </div>
        {[1, 2, 3].includes(type) && (
          <DataContent>
            <div>
              <div style={{ height: 32, display: 'flex', alignItems: 'bottom' }}>{t('内容')}</div>
              {type == 1 ? (
                <div className="readonly-content content">{fileData}</div>
              ) : (
                <TextArea
                  // autoSize={{ minRows: 11, maxRows: 11 }}
                  className="content"
                  value={fileData}
                  onChange={e => {
                    setFileData(e.target.value)
                    setChecked(true)
                  }}
                />
              )}
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'flex-end', height: '32px' }}>
                {type !== 1 && (
                  <Button
                    style={{ marginRight: 6 }}
                    disabled={!checked}
                    type="primary"
                    onClick={() => onCheckVariable()}
                  >
                    {t('检测变量')}
                  </Button>
                )}
                <span>{t('选择需要动态生成数据的变量')}</span>
              </div>
              <div className="variables content">
                {variables.length > 0 ? (
                  variables.map((item, index) => (
                    <div key={index} style={{ marginBottom: '15px' }}>
                      <Checkbox
                        onChange={() => toggle(item)}
                        value={item}
                        checked={isSelected(item)}
                      >
                        {`{{${item}}}`}
                      </Checkbox>
                    </div>
                  ))
                ) : (
                  <div style={{ lineHeight: '150px', textAlign: 'center' }}>{t('无')}</div>
                )}
              </div>
            </div>
            <div>
              <div style={{ height: '32px', display: 'flex', alignItems: 'flex-end' }}>
                {t('可使用的变量及释义')}
              </div>
              <div className="notes content">
                {variablesWithInterpretation.map((item, index) => (
                  <div className="note" key={index} style={{ display: 'flex' }}>
                    <div className="name">{`{{${item.name}}}`}</div>
                    <div className="value">{item.value}</div>
                  </div>
                ))}
              </div>
            </div>
          </DataContent>
        )}
        <Form.Item label={t('描述')} name="describe">
          {(description || description === '') && (
            <MarkdownEditor isEdit value={description} setValue={setDescription} />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}
const Readonly = styled.div`
  display: flex;
  margin-bottom: 20px;
  .name {
    color: #86909c;
    width: 80px;
  }
  .value {
    width: 870px;
    line-height: 1.2;
    color: #333333;
    //font-size: 12px;
  }
`
const DataContent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  textarea {
    resize: none;
    line-height: 1.5;
  }
  .content {
    width: 300px;
    height: 176px;
    margin-top: 12px;
    padding: 10px;
    word-wrap: break-word;
    word-break: break-all;
  }
  .empty-file {
    background: #f7f8f9;
    border-radius: 6px;
    //border: 1px dashed #d9d9d9;
    div {
      color: #666666;
      text-align: center;
      line-height: 180px;
    }
  }
  .readonly-content {
    background: #f7f8f9;
    border-radius: 6px;
    overflow-y: auto;
  }
  .variables {
    border-radius: 6px;
    border: 1px solid #d9d9d9;
    overflow-y: auto;
  }
  .notes {
    background: #f7f8f9;
    border-radius: 6px;
    font-size: 12px;
    line-height: 18px;
    overflow: scroll;
    padding-right: 0px;
    .note {
      display: flex;
    }
    .name {
      color: #86909c;
      width: 110px;
    }
    .value {
      color: #333333;
      font-size: 12px;
    }
  }
`
interface EmptyFileProps {
  failed: boolean
}
const EmptyFile = styled.div<EmptyFileProps>`
  border: 1px dashed ${props => (props.failed ? '#F5222D' : '#d9d9d9')};
  span {
    color: ${props => (props.failed ? '#F5222D' : '#666666')};
  }
`
